<template>
    <b-container fluid>
        <hr/>
        <h3>Project index</h3>
        <hr/>
        <b-button-group>
            <v-btn v-b-modal.create_project_modal :style="primaryStyle" :loading="loadingCreate"
                   :disabled="loadingCreate">New project
            </v-btn>
        </b-button-group>
        <hr/>
        <v-skeleton-loader
                :loading="this.loadingIndex"
                transition='fade-transition'
                ref="skeleton"
                type="table"
                class="mx-auto"
                width="100%">
            <b-table striped :items="projects"
                     :fields="['id', 'name', 'user_name', 'edit', 'connections', 'project_config', 'delete']">
                <template slot="edit" slot-scope="data">
                    <b-button @click="edit_project(data.item)" variant="primary">Edit</b-button>
                </template>
                <template slot="connections" slot-scope="data">
                    <b-button @click="editProjectConnections(data.item)" variant="secondary">Edit connections</b-button>
                </template>
                <template slot="project_config" slot-scope="data">
                    <b-button @click="editProjectConfig(data.item)" variant="secondary">Edit project config</b-button>
                </template>
                <template slot="delete" slot-scope="data">
                    <b-button @click="delete_project(data.item)" variant="danger">Delete</b-button>
                </template>
            </b-table>
        </v-skeleton-loader>

        <!--The create project modal-->
        <create-project v-bind:user_options="user_options" @project-created="project_created"
                        @change-create-loading="loadingCreate = !loadingCreate">
        </create-project>
        <!--The edit project modal-->
        <edit-project v-bind:user_options="user_options" v-bind:selected_project="to_edit_project"
                      @show-loading-pop-up="showLoadingPopUp"
                      @reset-loading-pop-up="resetLoadingPopUp"
                      @project-edited="project_edited">
        </edit-project>
    </b-container>
</template>

<script>
    import ProjectRepository from '../../repositories/project.repository';
    import CreateProject from './Create.vue';
    import EditProject from './Edit.vue';

    export default {
        components: {
            CreateProject,
            EditProject,
        },
        data() {
            return {
                to_edit_project: ProjectRepository.blankProject(),
                projects: [],
                users: [],
                loadingIndex: false,
                loadingCreate: false,
            }
        },
        created() {
            this.loadingIndex = true;
            ProjectRepository.getIndexData().then(res => {
                this.projects = res.data.projects;
                this.users = res.data.users;
                this.loadingIndex = false;
            }).catch(error => {
                this.loadingIndex = false;
            });
        },
        methods: {
            showLoadingPopUp(text) {
                this.$emit('show-loading-pop-up', text);
            },
            resetLoadingPopUp() {
                this.$emit('reset-loading-pop-up');
            },
            project_created(project) {
                this.projects.push(project);
            },
            project_edited(project) {
                this.projects.forEach(p => {
                    if (p.id === project.id) Object.assign(p, project);
                });
            },
            edit_project(data) {
                // Clone the selected item so that it can be edited without changing the original.
                this.to_edit_project = Object.assign({}, data);
                // Show the edit modal.
                this.$bvModal.show('edit_project_modal');
            },
            delete_project(data) {
                this.$emit('show-loading-pop-up', 'Deleting the selected project');
                ProjectRepository.delete(data.id).then(res => {
                    this.$emit('reset-loading-pop-up');
                    // Status 204 means no content, which is the response we would expect when deleting a record.
                    if (res.status === 204) {
                        // Remove the project from the local list to reflect the deletion.
                        this.projects = this.projects.filter(p => p.id !== data.id);
                        // Notify the user.
                        this.$bvToast.toast(`project ${data.name} successfully deleted.`, {
                            title: `project deleted.`,
                            variant: 'success',
                            solid: true
                        });
                    } else {
                        // If the status is not 204 something must have gone wrong.
                        // So we notify the user with a toast.
                        this.$bvToast.toast('Looks like something went wrong while deleting a project.', {
                            title: `project deletion error.`,
                            variant: 'danger',
                            solid: true
                        });
                    }
                }).catch(error => {
                    this.$emit('reset-loading-pop-up')
                });
            },
            editProjectConnections(project) {
                this.$router.push({path: `/projects/connections/${project.id}`});
            },
            editProjectConfig(project) {
                this.$router.push({path: `/projects/config/${project.id}`});
            }
        },
        computed: {
            user_options() {
                return this.users.map(u => {
                    return {value: u.id, text: u.firstname + " " + u.lastname};
                });
            },
        }
    }
</script>
